import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonIcon } from '@statsbomb/kitbag-components';

export function CopyToClipboardWithIcon({ icon, size, text, title, variant }) {
  const intl = useIntl();
  return (
    <ButtonIcon
      icon={icon}
      onClick={() => {
        navigator.clipboard.writeText(text);
      }}
      size={size}
      title={
        title ||
        intl.formatMessage({
          defaultMessage: 'Copy',
          description: 'Action: copy',
          id: '86527',
        })
      }
      variant={variant}
    />
  );
}

CopyToClipboardWithIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string.isRequired,
  title: PropTypes.string,
  variant: PropTypes.string,
};

CopyToClipboardWithIcon.defaultProps = {
  icon: 'Clone',
  size: 'regular',
  title: undefined,
  variant: 'secondary',
};

export default { CopyToClipboardWithIcon };
